import { EmployeeWithProfile } from "@/pages/OrgChartPage";

export interface Department {
  id: string;
  name: string;
  parent_department_id: string | null;
  sort_order: number;
}

export interface CanvasItem {
  id: string;
  type: 'department' | 'employee';
  x: number;
  y: number;
  data: Department | EmployeeWithProfile;
  tasks?: string;
}

export interface Connection {
  fromId: string;
  toId: string;
  fromSide: ConnectionSide;
  toSide: ConnectionSide;
}

export type ConnectionSide = 'top' | 'right' | 'bottom' | 'left';
export type ToolMode = 'select' | 'move' | 'connect';

export const NODE_WIDTH = 220;
export const NODE_HEIGHT = 88;
export const EMPLOYEE_NODE_HEIGHT = 110;
export const GRID_SIZE = 20;
export const SNAP_THRESHOLD = 10;
export const ALIGNMENT_THRESHOLD = 5;

export const CANVAS_MIN_WIDTH = 4000;
export const CANVAS_MIN_HEIGHT = 3000;
export const CANVAS_PADDING = 300;

export const MIN_ZOOM = 0.15;
export const MAX_ZOOM = 2.5;
export const ZOOM_STEP = 0.1;
